import React, { MouseEvent } from 'react';
import Logo from 'assets/Logo';
import LoginForm from 'components/structure/Login/Loginform';
import { Link } from 'react-router-dom';

export default function Login() {
  const handleContactUsClick = (event: MouseEvent<HTMLAnchorElement>): void => {
    event.preventDefault();
    window.open('https://b-line.io/contact-us', '_blank');
  };

  return (
    <div className="flex min-h-screen flex-col justify-center overflow-hidden sm:py-12 publicBackgroundImage">
      <div className="relative bg-primary2 px-6 pt-10 pb-8 w-full shadow-xl sm:mx-auto max-w-[460px] sm:rounded-lg sm:px-10 rounded">
        <div className="absolute top-10 left-1/2 transform -translate-x-1/2 mt-5">
          <Logo />
        </div>
        <div className="mx-auto max-w-md">
          <div className="py-8 text-center leading-7">
            <div className="relative top-10 bottom-10 left-1/2 transform -translate-x-1/2 mb-8 mt-4">
              <h3 className="text-3xl font-normal">Sign In</h3>
            </div>
            <div className="relative top-10 left-1/2 transform -translate-x-1/2">
              <LoginForm />
            </div>
            <div className="relative top-10 bottom-10 pt-4 text-sm">
              New user?{' '}
              <Link to="#" onClick={handleContactUsClick}>
                <u>Contact us</u>
              </Link>{' '}
              to create an account.
            </div>
          </div>
          <div className="relative pt-10 text-center text-neutral5 leading-4 text-sm">
            ©2024 B-Line Technologies Inc. All rights reserved.
          </div>
        </div>
      </div>
    </div>
  );
}
